var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Label } from '../Input';
import { InputWrapper } from '../../CurrencyInput';
import { ListModal } from '../../Modals/ListModal';
export function Select(_a) {
    var label = _a.label, onClick = _a.onClick, isOpen = _a.isOpen, onClose = _a.onClose, value = _a.value, options = _a.options, searchPlaceholder = _a.searchPlaceholder, filterItems = _a.filterItems, renderItems = _a.renderItems, renderCurrentValue = _a.renderCurrentValue, placeholder = _a.placeholder, disabled = _a.disabled;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx(Label, { children: label }), _jsx(InputWrapper, __assign({ style: {
                            alignItems: 'center',
                            cursor: disabled ? 'not-allowed' : 'pointer',
                        }, onClick: disabled ? undefined : onClick }, { children: value ? renderCurrentValue(value) : placeholder }))] }), _jsx(ListModal, { label: label, onClose: onClose, isOpen: isOpen, list: options, renderItems: renderItems, searchPlaceholder: searchPlaceholder, filterItems: filterItems })] }));
}
